var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayerSkipPrevious = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6222 16C17.7872 16 17.9455 16.0631 18.0622 16.1753C18.1789 16.2875 18.2444 16.4398 18.2444 16.5985V21.7016L27.2964 16.4904C27.5055 16.3681 27.7449 16.302 27.9896 16.2991C28.2343 16.2962 28.4753 16.3566 28.6875 16.4739C29.1541 16.7283 29.4442 17.222 29.4442 17.758V28.6055C29.4442 29.143 29.1541 29.6352 28.6875 29.8896C28.4753 30.0068 28.2343 30.0671 27.9896 30.0641C27.7449 30.0612 27.5055 29.9951 27.2964 29.8727L18.2444 24.6619V29.765C18.2444 29.9237 18.1789 30.076 18.0622 30.1882C17.9455 30.3004 17.7872 30.3635 17.6222 30.3635C17.4572 30.3635 17.2989 30.3004 17.1822 30.1882C17.0656 30.076 17 29.9237 17 29.765V16.5985C17 16.4398 17.0656 16.2875 17.1822 16.1753C17.2989 16.0631 17.4572 16 17.6222 16Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayerSkipPrevious);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/player-skip-previous.738dbf6a7bf1c8c5ecdbacde6254cb21.svg";